export default "__VITE_ASSET__1M74XikL__"